import { baseDialogStyles } from '../baseDialogStyles.js';
import * as R from 'ramda';
import { fade } from '@material-ui/core/styles/colorManipulator';

export const styles = (theme) => {
    const { palette, spacing } = theme;
    const baseStyles = baseDialogStyles(theme);

    const styles = {
        content: {
            padding: [[30, 40, 0]],
            wordBreak: 'break-word'
        },
        header: {
            background: palette.error.main,
            color: palette.text.white
        },
        messageContainer: {
            background: fade(palette.error.light, 0.1),
            color: palette.error.main,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 4,
            padding: spacing.unit * 2
        },
        helpText: {
           marginTop: spacing.unit * 2
        }
    };

    return R.mergeDeepRight(baseStyles, styles);
};
